const date = new Date()
const month = date.getMonth()
const year = date.getFullYear()
const newMonth = month + 1 < 10 ? `0${month + 1}` : `${month + 1}`
const dateIn = `${newMonth}-${year}`

export { date, dateIn }
